/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ad_Shot_Source_TextInputs */

const en_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have ${i?.count} shot change markers in the Marker Store. Would you like to use your existing markers or detect scene changes automatically?`)
};

const fr_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez des marqueurs de changement de plan ${i?.count} dans la boutique de marqueurs. Souhaitez-vous utiliser vos marqueurs existants ou détecter automatiquement les changements de scène ?`)
};

const de_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie haben ${i?.count} Szenenwechselmarker im Marker-Shop. Möchten Sie Ihre vorhandenen Marker verwenden oder Szenenwechsel automatisch erkennen lassen?`)
};

const it_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nel Marker Store sono presenti ${i?.count} marcatori di cambio inquadratura. Desideri utilizzare i marcatori esistenti o rilevare automaticamente i cambi di scena?`)
};

const ru_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В хранилище маркеров у вас есть маркеры смены кадра ${i?.count}. Хотите ли вы использовать существующие маркеры или автоматически определять смену сцены?`)
};

const es_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tienes marcadores de cambio de toma ${i?.count} en el Almacén de marcadores. ¿Te gustaría usar tus marcadores existentes o detectar los cambios de escena automáticamente?`)
};

const zh_cn2_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的标记库中已有 ${i?.count} 个镜头切换标记。您想使用现有标记还是自动检测场景切换？`)
};

const ja_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マーカーストアには${i?.count}個のショットチェンジマーカーがあります。既存のマーカーを使用しますか、それともシーンチェンジを自動的に検出しますか？`)
};

const hi_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मार्कर स्टोर में आपके पास ${i?.count} शॉट चेंज मार्कर हैं। क्या आप अपने मौजूदा मार्करों का उपयोग करना चाहेंगे या दृश्य परिवर्तनों का स्वचालित रूप से पता लगाना चाहेंगे?`)
};

const pt_pt2_ad_shot_source_text = /** @type {(inputs: Ad_Shot_Source_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você tem ${i?.count} marcadores de mudança de cena no Armazém de Marcadores. Deseja usar seus marcadores existentes ou detectar mudanças de cena automaticamente?`)
};

/**
* | output |
* | --- |
* | "You have {count} shot change markers in the Marker Store. Would you like to use your existing markers or detect scene changes automatically?" |
*
* @param {Ad_Shot_Source_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_text = /** @type {((inputs: Ad_Shot_Source_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_shot_source_text(inputs)
	if (locale === "de") return de_ad_shot_source_text(inputs)
	if (locale === "it") return it_ad_shot_source_text(inputs)
	if (locale === "ru") return ru_ad_shot_source_text(inputs)
	if (locale === "es") return es_ad_shot_source_text(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_shot_source_text(inputs)
	if (locale === "ja") return ja_ad_shot_source_text(inputs)
	if (locale === "hi") return hi_ad_shot_source_text(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_shot_source_text(inputs)
	return en_ad_shot_source_text(inputs)
});